import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UniversalListData } from 'src/app/interfaces/universal-list-data';
import { ServerTypes } from 'src/app/models/servers';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class ListDataResolverService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public resolveListData(
    source?: string,
    queryParams?: HttpParams,
    ...args
  ): Observable<any> {
    const paramsToSet = queryParams || new HttpParams();
    console.log('1_' + this.url + source.toString());
    return this.http.get(this.url + source, { params: paramsToSet });
  }
}
